/// <reference path="../services/datacontext.js" />
// app/tirocinante/aziende.js

(function () {
    'use strict';
    var controllerId = 'cndAccreditamento';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '_', cndAccreditamento]);

    function cndAccreditamento($rootScope, $scope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter, _) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');


        var vm = this;
        vm.title = 'Accreditamento';
        vm.view = 'detail';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "accreditamento"; //Utilizzato per pannello authorization		
        vm.authorization = {};
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.maxStep = 3;
        vm.errorAccess = '';
        vm.tSourceCode_ACCR = 'ACCR';
        vm.isVisibleLinkDomanda = false;

        //Pannelli dei dati (viewAccred)
        vm.showPanelAccred1 = true;
        vm.showPanelAccred2 = true;
        vm.showPanelAccred3 = true;
        vm.showPanelAccred4 = true;
        vm.setShowPanelAccred1 = setShowPanelAccred1;
        vm.setShowPanelAccred2 = setShowPanelAccred2;
        vm.setShowPanelAccred3 = setShowPanelAccred3;
        vm.setShowPanelAccred4 = setShowPanelAccred4;

        //Pannelli dei dati (viewAtt)
        vm.showPanelAtt1 = true;
        vm.showPanelAtt2 = true;
        vm.showPanelAtt3 = true;
        vm.setShowPanelAtt1 = setShowPanelAtt1;
        vm.setShowPanelAtt2 = setShowPanelAtt2;
        vm.setShowPanelAtt3 = setShowPanelAtt3;

        //Pannelli dei dati (viewRiep)
        vm.showPanelRiep1 = true;
        vm.setShowPanelRiep1 = setShowPanelRiep1;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.cndProgetto = {};
        vm.urlRoot = datacontext.accreditamento_getURL();


        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Ragione Sociale', 'Codice Fiscale', 'Cod Ateco', 'Forma Giuridica'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.attach = [];
        vm.list.b_attach = false;

        vm.list.cndAccreditamentiSedi = [];

        vm.getAllCNDAccreditamentiSedi = getAllCNDAccreditamentiSedi;
        vm.addCNDAccreditamentoSede = addCNDAccreditamentoSede;
        vm.editCNDAccreditamentoSede = editCNDAccreditamentoSede;
        vm.deleteCNDAccreditamentoSede = deleteCNDAccreditamentoSede;

        //Attach 2
        vm.tAttach_Needed = [];
        vm.list.attach_accr = [];
        vm.addAttach = addAttach;
        vm.getListAttach = getListAttach;
        vm.deleteAttach = deleteAttach;
        vm.extractP7MFile = getExtractP7MFile;
        vm.extractP7MInfo = getExtractP7MInfo;
        vm.populateAttach = populateAttach;

        

        //Conteggio Elenchi
        vm.countAttachProfilo = function () {
            var filter = {};
            return filterFilter(vm.list.attach, filter).length;
        }


        //Filtro
        vm.fAttach = {};
        vm.setfAttach = setfAttach;

        //Elenchi per filtri e finestra modale di Create
        vm.province = [];
        vm.provinceSicilia = [];
        vm.comuni = [];
        vm.tSource = {};
        vm.tAttach = [];
        vm.lstFormaGiuridica = [];
        vm.lstAteco = [];
        //per anagrafica rappresentante LEGALE
        vm.provinceNasc_L = [];
        vm.comuniNasc_L = [];
        vm.paesiNasc_L = [];

        vm.cmblist = {};
        vm.cmblist.res_province = [];
        vm.cmblist.res_comuni = [];
        vm.cmblist.res_paesi = [];
        vm.cmblist.dom_province = [];
        vm.cmblist.dom_comuni = [];
        vm.cmblist.dom_paesi = [];
        vm.cmblist.cittadinanze = [];
        vm.cmblist.sedeOp_province = [];
        vm.cmblist.sedeOp_comuni = [];

        vm.reset_PaeseNasc = reset_PaeseNasc;
        vm.reset_PaeseRes = reset_PaeseRes;
        vm.resetComuni_Res = resetComuni_Res;
        vm.reset_SedeOperativa = reset_SedeOperativa;
        vm.resetComuni_SedeOp = resetComuni_SedeOp;
        vm.resetComuniNasc = resetComuniNasc;
        vm.resetComuni = resetComuni;
        vm.reset_bEnte = reset_bEnte;


        //Metodi su interfaccia
        vm.activated = false;

        vm.setStep = setStep;
        vm.printAll = printAll;


        //vm.addAttach = addAttach;
        //vm.deleteAttach = deleteAttach;
        vm.setCompleted = setCompleted;
        vm.setSent = setSent;
        vm.unlock = unlockItem;
        vm.setAttachChecked = setAttachChecked;


        //Gestione conferma input di tipo Email
        vm.confirm = {};

        //vm.get = getRecord;
        //vm.update = saveOrUpdateItem;
        vm.saveAccred = saveOrUpdateItem;
        vm.delete = deleteItem;

        
        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;

        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            if (iOpened == 1)
                vm.opened1 = true;
            else if (iOpened == 2)
                vm.opened2 = true;
            else if (iOpened == 3)
                vm.opened3 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.L_DtNasc = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.Decreto_Data = '';
                vm.changed = true;
            }
            else if (iOpened == 3) {
                vm.record.DtLegaleRapp = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        loadStepParams();
        activate();

        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {
                    if ($routeParams.accreditamentoUID != null) {
                        return getRecordByUID($routeParams.accreditamentoUID).then(function () {
                            if (!vm.record.Completed) {
                                var promises = [getTSource(vm.tSourceCode_ACCR), getTAttach(vm.tSourceCode_ACCR), getTAttachNeeded(vm.tSourceCode_ACCR), getPaesi_Nasc(), getProvince_Nasc(), getProvince(), getPaesi_Res(), getProvince_Res(), getProvince_SedeOp()];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                            else if (!vm.record.AttachChecked) {
                                var promises = [getTSource(vm.tSourceCode_ACCR), getTAttach(vm.tSourceCode_ACCR), getTAttachNeeded(vm.tSourceCode_ACCR)];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                        });
                    }
                    else {
                        vm.record.Id = 0;
                        vm.record.L_PaeseNascId = 0;
                        vm.confirm.Email = '';
                        vm.confirm.PEC = '';

                        var promises = [getTSource(vm.tSourceCode_ACCR), getTAttach(vm.tSourceCode_ACCR), getTAttachNeeded(vm.tSourceCode_ACCR), getPaesi_Nasc(), getProvince_Nasc(), getProvince(), getPaesi_Res(), getProvince_Res(), getProvince_SedeOp()];
                        return common.activateController(promises, controllerId)
                            .then(function () {
                                return setStep(0);
                            });
                    }

                    vm.sectionMenu = sectionMenu.setSection(vm.title);
                    vm.activated = true;
                });
                sectionMenu.setProjectUId($routeParams.projectUID);
            }
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function nextStep() {
            bDialog.confirmationDialog('Attenzione', 'Si sta passando alla Fase successiva, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    setStep(vm.actualStep + 1);
                },
                function () { //NO
                    //
                }
            );
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "A";
            vm.titlesStep[0] = "Fase A";
            vm.subtitlesStep[0] = "Domanda di partecipazione";
            vm.descriptionsStep[0] = "In questa prima fase &egrave; richiesto l'inserimento dei dati necessari alla compilazione della 'Domanda di partecipazione' (Allegato 2 e Allegato 3).<br/>&Egrave; possibile procedere alla fase successiva solo dopo aver inserito e salvato tutte le informazioni richieste in questa fase.";

            vm.labelsStep[1] = "B";
            vm.titlesStep[1] = "Fase B";
            vm.subtitlesStep[1] = "Upload Documentale";
            vm.descriptionsStep[1] = "In questa fase &egrave; richiesta la convalida dei dati; effettuata la convalida occore scaricare l'allegato 2 e l'allegato 3 generati dal portale, firmarli (gli allegati vanno firmato digitalmente) e ricaricarli unitamente all'altra documentazione richiesta, compilando integralmente l'elenco.";

            vm.labelsStep[2] = "C";
            vm.titlesStep[2] = "Fase C";
            vm.subtitlesStep[2] = "Stampa ricevuta";
            vm.descriptionsStep[2] = "In questa fase &egrave possibile stampare la 'Ricevuta di partecipazione' da conservare.";
        }

        function setStepDefault() {
            if (vm.record.AttachChecked) {
                setStep(2);
            } else if (vm.record.Completed) {
                setStep(1);
            } else {
                setStep(0);
            }
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            switch (vm.actualStep) {
                case 0:
                    setView('viewAccred');
                    break;
                case 1:
                    populateAttach();
                    setView('viewAtt');
                    break;
                case 2:
                    setView('viewRiep');
                    break;
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            var spanEdit = 'span-select';
            var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = (vm.record != undefined && vm.record.Completed);
            vm.stepCompleted[1] = (vm.record != undefined && vm.record.AttachChecked);
            vm.stepCompleted[2] = (vm.record != undefined && vm.record.Sent);

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAccred':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < (vm.maxStep - 1) && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.loading, form);
            //disable = form.$pristine || form.$invalid || vm.loading;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.loading || vm.record.Completed
                        || (vm.record.PEC != undefined && vm.record.PEC.toLowerCase() != vm.confirm.PEC.toLowerCase())
                        || (vm.record.Email != undefined && vm.record.Email.toLowerCase() != vm.confirm.Email.toLowerCase())
                        || (!vm.record.bEnteOpeLegis && !vm.record.bEnteSgoSsf);
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.loading, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }

        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }


        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }
        //Gestione per viewAccred
        function setShowPanelAccred1() {
            return vm.showPanelAccred1 = !vm.showPanelAccred1;
        }
        function setShowPanelAccred2() {
            return vm.showPanelAccred2 = !vm.showPanelAccred2;
        }
        function setShowPanelAccred3() {
            return vm.showPanelAccred3 = !vm.showPanelAccred3;
        }
        function setShowPanelAccred4() {
            return vm.showPanelAccred4 = !vm.showPanelAccred4;
        }
        //Gestione per viewAtt
        function setShowPanelAtt1() {
            return vm.showPanelAtt1 = !vm.showPanelAtt1;
        }
        function setShowPanelAtt2() {
            return vm.showPanelAtt2 = !vm.showPanelAtt2;
        }
        function setShowPanelAtt3() {
            return vm.showPanelAtt3 = !vm.showPanelAtt3;
        }
        //Gestione per viewRiep
        function setShowPanelRiep1() {
            return vm.showPanelRiep1 = !vm.showPanelRiep1;
        }


        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;

                        var dt = new Date();
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }

                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Partita IVA');

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    }
                );
        }

        function setCompleted() {
            if (!vm.record.Sent && !vm.record.Completed)
                bDialog.confirmationDialog('Attenzione', 'Convalidando i dati non sar\xE0 possibile apportare alcuna modifica ai dati inseriti nella \'Fase A\'. Vuoi convalidare?', 'Convalida').then(
                    function () { //YES
                        vm.record.Completed = true;
                        vm.loading = true;
                        return saveOrUpdateItem().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Completed = false;
                                return true;
                            }
                            setClassSeqWiz();
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
        }

        function setSent() {
            if (!vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti.', 'Procedi').then(
                    function () { //YES
                        vm.record.Sent = true;
                        vm.loading = true;
                        return saveOrUpdateItem().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Sent = false;
                                return true;
                            }
                            setClassSeqWiz();
                            printRicevuta();
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                printRicevuta();
            }
        }

        function setAttachChecked() {
            if (!vm.record.AttachChecked) {
                bDialog.confirmationDialog('Attenzione', 'Si sta proseguendo alla "Fase C", pertanto, non sar\xE0 possibile tornare indietro e/o aggiungere, modificare, eliminare gli allegati caricati a sistema. Procedere? ', 'Procedi').then(
                    function () { //YES
                        vm.record.AttachChecked = true;
                        vm.loading = true;
                        return saveOrUpdateItem().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.AttachChecked = false;
                                setStep(1);
                                return false;
                            }
                            setClassSeqWiz();
                            setStep(2);
                            //setView('viewRiep');
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(1);
                        return true;
                    }
                );
            }

        }

        function unlockItem() {
            if (vm.record.Completed) {
                var item = vm.record;
                var msg = item.UId;
                bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare l\'ammissione (' + msg + ')', 'OK').then(
                    function () { //YES
                        return datacontext.cndAccreditamento_unlock(item).then(function (data) {
                            if (data != "204") return logError('Errore: operazione non consentita');
                            vm.record.Completed = false;
                            vm.records[vm.index] = vm.record;
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

        //***************************
        // Get URL Allegato ACCREDITAMENTO

        function getPDF_All(index) {
            vm.loading = false;
            return datacontext.cndAccreditamento_findPDFAll($routeParams.accreditamentoUID, $routeParams.projectUID, index)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        switch (index) {
                            case 2:
                                return vm.linkPDFAll2 = data.url;
                                break;
                            case 3:
                                return vm.linkPDFAll3 = data.url;
                                break;
                        }
                    }
                });
        }

        //*******************************
        // Print PDF ACCREDITAMENTOs

        function printAll(index) {
            vm.loading = true;
            return datacontext.cndAccreditamento_printPDFAll($routeParams.projectUID, $routeParams.accreditamentoUID, index)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        //recupero allegato appena creato
                        var a = document.createElement("a");
                        a.setAttribute('style', 'display:none');
                        document.body.appendChild(a);

                        a.href = data.url;
                        if ($rootScope.detectIE()) {
                            a.target = 'hiddenIframe';
                        }
                        else
                            a.download = 'Allegato' + index + '_' + $routeParams.accreditamentoUID + '.pdf';
                        a.click();
                        document.body.removeChild(a);

                        switch (index) {
                            case 2:
                                return vm.linkPDFAll2 = data.url;
                                break;
                            case 3:
                                return vm.linkPDFAll3 = data.url;
                                break;
                        }
                    } else
                        return true;
                });
        }

        //*******************************
        // Print PDF RICEVUTA
        function printRicevuta() {
            if (vm.record.Sent) {
                vm.loading = true;
                return datacontext.cndAccreditamento_printRicevuta($routeParams.projectUID, $routeParams.accreditamentoUID)
                    .then(function (data) {
                        vm.loading = false;
                        if (data && data.url) {
                            //recupero allegato appena creato
                            var a = document.createElement("a");
                            a.setAttribute('style', 'display:none');
                            document.body.appendChild(a);

                            a.href = data.url;
                            if ($rootScope.detectIE()) {
                                a.target = 'hiddenIframe';
                            }
                            else
                                a.download = 'Ricevuta_' + $routeParams.accreditamentoUID + '.pdf';
                            a.click();
                            document.body.removeChild(a);

                            getRecordByUID($routeParams.accreditamentoUID);
                            return vm.linkPDFRicevuta = data.url;
                        } else
                            return true;
                    });
            }
        }

        //=====================================

        function setRecord(data) {
            vm.record = data;
            if (vm.record.Deleted || vm.record.Annulled) {
                vm.errorAccess = 'linkError';
                return;
            }
            if (vm.record.Completed)
                return;

            //Abilita questo codice solo per sistemazioni grafiche della comunicazione Link di Accesso
            vm.isVisibleLinkDomanda = true;

            //Reset campi Notifiche
            vm.validFieldsCF = true;
            vm.validPIVA = true;
            vm.validCF = true;


            if (vm.record.L_DtNasc != null) vm.record.L_DtNasc = new Date(vm.record.L_DtNasc);
            if (vm.record.Decreto_Data != null) vm.record.Decreto_Data = new Date(vm.record.Decreto_Data);
            if (vm.record.DtLegaleRapp != null) vm.record.DtLegaleRapp = new Date(vm.record.DtLegaleRapp);
            if (vm.record.DtRicevuta != null) vm.record.DtRicevuta = new Date(vm.record.DtRicevuta);
            if (vm.record.Email != null) vm.confirm.Email = vm.record.Email;
            if (vm.record.PEC != null) vm.confirm.PEC = vm.record.PEC;


            //Azzera liste
            //vm.list.attach = [];
            //vm.list.b_attach = false;
            //vm.existsCF = false;
            //vm.existsPIVA = false;
            //vm.existsIPA = false;

            //Aggiorno campi
            getComuni(vm.record.ProvinciaId);
            getComuniNasc(vm.record.L_ProvNascId);
            getComuni_Res(vm.record.L_ResProvinciaId);
            getComuni_SedeOp(vm.record.SedeOp_ProvinciaId);
        }

        /*
		function getRecord(id, index) {
            if (vm.province.length == 0) getProvince();
            if (vm.cmblist.res_province.length == 0) getProvince_Res();

			return datacontext.cndAccreditamento_get(id).then(function (data) {
                vm.index = index;
                setRecord(data); //vm.record = data;

				setView('detail');
			});
        }
        */

        function showAlertDivs(errorAccess) {
            var msg = '';

            vm.errorAccess = errorAccess;

            if (errorAccess == 'linkError') {
                msg = 'Attenzione! Il link utilizzato e\' errato.';
            }

            if (msg != '') return logError(msg);

            return false;
        }

        function getRecordByUID(uid) {
            if (vm.province.length == 0) getProvince();

            return datacontext.cndAccreditamento_getByUID(uid, $routeParams.projectUID).then(function (data) {
                if (data == null || $.isNumeric(data) || data.Id == 0) {
                    showAlertDivs('linkError');
                    return false;
                }

                //Parametro di appoggio per send_Email
                vm.record.ProgettoUId = $routeParams.projectUID;
                //Riduco il pannello con le modalit� di utilizzo dello strumento
                vm.showInfoMsg = false;

                setRecord(data); //vm.record = data;
                setStepDefault();

                //vm.list.cndAccreditamentiSedi = [];
                //getAllCNDAccreditamentiSedi(vm.record.ProgettoId, vm.record.Id);

                //vm.list.attach = [];
                //getListAttach(vm.record.Id);

                //setView('detail');
            });
        }




        function saveOrUpdateItem() {
            var msgExistAccr = 'Attenzione: tentativo di duplicazione. La "Partita IVA" dell\'azienda \xE8 gi\xE0 presente a sistema. '

            if (typeof (vm.record.Id) == 'undefined' || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Dopo il primo salvataggio non sar\xE0 pi\xF9 possibile modificare il campo "CODICE FISCALE" ed il campo "PARTITA IVA". Procedere?', 'OK').then(
                    function () { //YES
                        //Parametro di appoggio per send_Email
                        vm.record.ProgettoUId = $routeParams.projectUID;
                        vm.loading = true;
                        return datacontext.cndAccreditamento_add(vm.record).then(function (data) {
                            vm.loading = false;

                            if (data == "409") {
                                logError(msgExistAccr); //Domanda esistente
                                return data;
                            }
                            if (data == "400") {
                                logError('Errore campi non validi. ');
                                return data;
                            }
                            if (data == "304") {
                                logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                                return data;
                            }
                            if (data == "300") {
                                logError('Errore: partita IVA non valida. ');
                                return data;
                            }
                            if ($.isNumeric(data)) {
                                logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                                return data;
                            }

                            if (data) {
                                setRecord(data); //vm.record = data;

                                $routeParams.accreditamentoUID = vm.record.UID;
                                //getListAttach(vm.record.Id);

                                if (vm.record.Id > 0) {
                                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                                    vm.showInfoMsg = false;

                                    //Riduco i pannelli dei dati dopo averli convalidati
                                    //vm.showPanel2 = false;
                                    //vm.showPanel3 = false;
                                }
                                return logSuccess('E\' stata inviata una email all\'indirizzo ' + vm.record.Email + ' con i dati inseriti. ');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            } else {
                vm.loading = true;
                return datacontext.cndAccreditamento_update(vm.record).then(function (data) {
                    vm.loading = false;
                    if (data == "409") {
                        logError(msgExistAccr); //Domanda esistente
                        return data;
                    }
                    if (data == "417") {
                        logError("Attenzione dati mancanti. ");
                        return data;
                    }
                    if (data == "304") {
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "406") {
                        vm.record.Sent = false;
                        logError("Attenzione mancano alcuni allegati, inserirli prima di effettuare la trasmissione. ");
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        logError('Errore generico. Impossibile proseguire.');
                        return data;
                    }

                    if (data) {
                        setRecord(data); //vm.record = data;
                        $routeParams.accreditamentoUID = vm.record.UID;
                        logSuccess('Dati salvati');
                        return true;
                    }
                });
            }
        }


        function deleteItem(item) {
            var msg = ' l\'accreditamento dell\'azienda : ' + item.RagioneSociale;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAccreditamento_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }


        


        function reset_PaeseNasc() {
            if (vm.record.L_PaeseNascId != 0) {
                vm.record.L_ProvNascId = 0;
                resetComuniNasc(0);
            }
        }

        //******************************
        // Residenza
        function getPaesi_Res() {
            if (vm.cmblist.res_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.res_paesi = data;
            });
        }

        function getProvince_Res() {
            if (vm.cmblist.res_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.res_province = data;
            });
        }

        function resetComuni_Res(idprov) {
            vm.record.L_ResComuneId = 0;
            getComuni_Res(idprov);
        }
        function getComuni_Res(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.res_comuni = [];
            }

            if (vm.record.ResProvinciaId != idprov)
                vm.cmblist.res_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.res_comuni = data;
            });
        }


        function reset_PaeseRes() {
            if (vm.record.L_ResPaeseId != 0) {
                vm.record.L_ResProvinciaId = 0;
                resetComuni_Res(0);
            }
        }

        //Sede Operativa
        function getProvince_SedeOp() {
            if (vm.cmblist.sedeOp_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.sedeOp_province = data;
            });
        }

        function resetComuni_SedeOp(idprov) {
            vm.record.SedeOp_ComuneId = 0;
            getComuni_SedeOp(idprov);
        }
        function getComuni_SedeOp(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.sedeOp_comuni = [];
            }

            if (vm.record.SedeOp_ProvinciaId != idprov)
                vm.cmblist.sedeOp_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.sedeOp_comuni = data;
            });
        }


        function reset_SedeOperativa() {
            if (vm.record.bSedeOperativa == undefined || vm.record.bSedeOperativa == false) {
                vm.record.SedeOp_Indirizzo = '';
                vm.record.SedeOp_CAP = '';
                vm.record.SedeOp_ProvinciaId = 0;
                vm.record.SedeOp_ComuneId = 0;
            }
        }


        //**********************************************************************
        //GESTIONE ATTACH 2

        function populateAttach() {
            vm.accr_ref = '';
            if (vm.record != undefined && vm.record.Id != 0 && vm.record.Id != undefined) {
                vm.accr_ref = vm.record.L_Cognome + ' ' + vm.record.L_Nome + ' (' + vm.record.L_CodiceFiscale + ')';
                return getListAttach().then(function () {
                    return true;
                });
            }
        }

        function getListAttach() {
            vm.list.attach_accr = [];
            return datacontext.attach_getAllCND(0, 0, $routeParams.projectUID, $routeParams.accreditamentoUID, vm.tSourceCode_ACCR, 0, vm.record.Id, vm.fAttach.TAttachId, '').then(function (data_ATT) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data_ATT)) vm.list.attach_accr = data_ATT;

                return datacontext.tAttach_getAll(0, 0, vm.tSourceCode_ACCR, 0, '', 0, '').then(function (data_TA) {
                    vm.tAttach_Needed = data_TA;

                    return datacontext.tAttachVisibility_getAll(0, 0, vm.tSourceCode_ACCR).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        vm.tAttach_Needed.forEach(function (item_TA) {
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.Name;

                            if (typeof (vm.list.attach_accr) == 'undefined') vm.list.attach_accr = [];
                            var myrec = _.find(vm.list.attach_accr, { 'TAttachId': item_TA.Id });
                            var myTAV = _.find(tAttVis, { 'TAttachId': item_TA.Id });

                            if (typeof (myTAV) == 'undefined') {
                                myTAV = {};
                                myTAV.bRead = true;
                                myTAV.bInsert = true;
                                myTAV.bUpdate = true;
                                myTAV.bDelete = true;
                                myTAV.iTags = 0;
                            }

                            att.bRead = myTAV.bRead;
                            att.bInsert = myTAV.bInsert;
                            att.bUpdate = myTAV.bUpdate;
                            att.bDelete = myTAV.bDelete;
                            att.iTags = myTAV.iTags;

                            if (typeof (myrec) == 'undefined') {
                                if (att.bRead)
                                    vm.list.attach_accr.push(att);
                            }
                            else {
                                myrec.bRead = myTAV.bRead;
                                myrec.bInsert = myTAV.bInsert;
                                myrec.bUpdate = myTAV.bUpdate;
                                myrec.bDelete = myTAV.bDelete;
                                myrec.iTags = myTAV.iTags;

                                var items = _.groupBy(vm.list.attach_accr, { 'TAttachId': item_TA.Id });

                                items.true.forEach(function (i) {
                                    i.bRead = myTAV.bRead;
                                    i.bInsert = myTAV.bInsert;
                                    i.bUpdate = myTAV.bUpdate;
                                    i.bDelete = myTAV.bDelete;
                                    i.iTags = myTAV.iTags;
                                });

                                if (myrec.bInsert) {
                                    if (item_TA.MaxValue == 99 || item_TA.MaxValue > items.true.length)
                                        vm.list.attach_accr.push(att);
                                }
                            }
                        });
                    });
                });

                return vm.list.attach_accr;
            });
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {
                return vm.tAttach_Needed = data;
            });
        }

        function getExtractP7MFile(id) {
            return datacontext.attach_extract(id).then(function (data) {
                if (data == "ERR01") return logError("Errore: il documento non \xE8 un documento 'P7M' valido. ");
                if (data == "ERR02") return logError("Errore: documento non trovato. ");
                if (data == "ERR03") return logError("Errore: il documento non ha firma digitale. ");

                var url = data;
                window.open(url, 'Download');
            });
        }

        function getExtractP7MInfo(id) {
            var fileName = "";
            return datacontext.attach_extractDigitalSignInfo(id).then(function (data) {
                fileName = data;

                if (data) {
                    common.$http.get('/api/pdf/GetVerifySign?id=' + id, { responseType: 'arraybuffer' })
                        .then(function (response) {
                            if (response.status == 204) {

                                logError('Il documento non ha Firma Digitale');
                                return;
                            }

                            var a = document.createElement("a");
                            a.setAttribute('style', 'display:none');
                            document.body.appendChild(a);
                            var file = new Blob([response.data], { type: 'application/pdf' });
                            var fileURL = URL.createObjectURL(file);
                            a.href = fileURL;
                            fileName = fileName.substring(0, fileName.indexOf('.'));

                            if ($rootScope.detectIE())
                                window.navigator.msSaveBlob(file, 'VerificaFirma_' + fileName + '.pdf');
                            else
                                a.download = 'VerificaFirma_' + fileName + '.pdf';

                            a.click();
                            document.body.removeChild(a);
                        })
                        .catch(function (message) {
                            logError('Impossibile scaricare il file');
                        });
                }
            });

        }

        // DELETE ATTACH2
        function deleteAttach(item) {
            if (item == undefined) return;

            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: entit\xE0 bloccata. ');
                    if (data == "401") return logError('Attenzione: azione non autorizzata. ');
                    if (data == "404") return logError('Attenzione: azione non autorizzata. ');

                    //Popolo l'oggetto att da cancellare
                    var index = vm.list.attach_accr.indexOf(item)
                    var att = {};
                    att.TAttachId = vm.list.attach_accr[index].TAttachId;
                    att.TAttach = vm.list.attach_accr[index].TAttach;

                    return datacontext.tAttachVisibility_getAll(0, 0, vm.tSourceCode_ACCR).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        var myTAV = _.find(tAttVis, { 'TAttachId': att.TAttachId });

                        if (typeof (myTAV) == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        att.bRead = myTAV.bRead;
                        att.bInsert = myTAV.bInsert;
                        att.bUpdate = myTAV.bUpdate;
                        att.bDelete = myTAV.bDelete;
                        att.iTags = myTAV.iTags;

                        //Individuo la tipologia corrispondente
                        var item_TA = _.find(vm.tAttach_Needed, { 'Id': att.TAttachId });
                        //Raggruppo la lista per tipologia
                        var items = _.groupBy(vm.list.attach_accr, { 'TAttachId': att.TAttachId });

                        //Se ho un allegato per la tipologia
                        if (items.true.length == 1 || item_TA.MaxValue == items.true.length) {
                            vm.list.attach_accr[index] = att; //Ripulisco il record
                        }
                        else if (item_TA.MaxValue > items.true.length) {
                            //Rimuovo l'oggetto
                            vm.list.attach_accr.splice(index, 1);
                        }
                    });
                });
            });
        }


        // ADD ATTACH2
        function addAttach(tAttachId) {
            var recTSource = {};
            var recSource = {};

            if (vm.record != undefined && vm.record.Id != undefined && vm.record.Id != 0) {
                recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
                recSource = { Id: vm.record.Id, Name: vm.accr_ref };

                var modalInstance = modal.open({
                    templateUrl: '/app/attach/modal/attachAdd2.html?version=56',
                    controller: 'attachAdd2',
                    backdrop: 'static',
                    resolve: {
                        tSource: function () {
                            return [recTSource];
                        },
                        tSourceCode: function () {
                            return vm.tSource.Code;
                        },
                        tSourceId: function () {
                            return vm.tSource.Id;
                        },
                        source: function () {
                            return [recSource];
                        },
                        sourceId: function () {
                            return recSource.Id;
                        },
                        tAttach: function () {
                            return vm.tAttach_Needed;
                        },
                        tAttachId: function () {
                            return tAttachId;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                    if (returnItem == "400") return logError('Errore registrazione dati');

                    logSuccess('Dato salvato con successo! ');
                    populateAttach();
                }, function () {
                    //log('Modal dismissed at: ' + new Date());
                });

                return true;
            } else return;
        };

        //************************END*****************************


        //=============================
        // CAMPI RESET

        function reset_bEnte(index) {
            switch (index) {
                case 1:
                    if (vm.record.bEnteSgoSsf) {
                        vm.record.bEnteOpeLegis = false;
                    }
                    break;
                case 2:
                    if (vm.record.bEnteOpeLegis) {
                        vm.record.bEnteSgoSsf = false;
                    }
                    break;
                case 3:
                    if (!vm.record.bEntePrivato) {
                        vm.record.Dich_01 = false;
                    }
                    break;
            }

            if (!vm.record.bEnteSgoSsf) {
                vm.record.Decreto_Num = '';
                vm.record.Decreto_Data = '';
            }

        }



        //======================

        //Elenchi Parametri
        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }


        function getProvince() {
            if (vm.province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.province = data;
            });
        }

        function getProvinceSicilia(regioneId) {
            if (vm.provinceSicilia.length > 0) return;

            datacontext.arrProvinceByReg(regioneId).then(function (data) {
                vm.provinceSicilia = data;
            });
        }

        function resetComuni(idprov) {
            vm.record.ComuneId = 0;
            getComuni(idprov);
        }
        function getComuni(idprov) {
            if (!idprov || idprov == 0) {
                return vm.comuni = [];
            }

            if (vm.record.ProvinciaId != idprov)
                vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }

        function getPaesi_Nasc() {
            if (vm.paesiNasc_L.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.paesiNasc_L = data;
            });
        }

        function getProvince_Nasc() {
            if (vm.provinceNasc_L.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.provinceNasc_L = data;
            });
        }

        function resetComuniNasc(idprov) {
            vm.record.L_ComuneNascId = 0;
            getComuniNasc(idprov);
        }

        function getComuniNasc(idprov) {
            if (!idprov || idprov == 0) {
                return vm.comuniNasc_L = [];
            }

            if (vm.record.L_ProvNascId != idprov)
                vm.comuniNasc_L = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuniNasc_L = data;
            });
        }


        //Metodi interfaccia Filtri
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        //*************************************
        //cndAccreditamenti SEDI
        function getAllCNDAccreditamentiSedi(cndProgettoId, cndAccreditamentoId) {
            vm.list.cndAccreditamentiSedi = [];
            return datacontext.cndAccreditamentoSede_getAll(0, 0, '', cndProgettoId, cndAccreditamentoId, 0, 0, '').then(function (data) {
                return vm.list.cndAccreditamentiSedi = data;
            });
        }

        function cndAccreditamentoSede_exists(cndAccreditamentoId, provinciaId, comuneId) {
            return datacontext.cndAccreditamentoSede_exists(cndAccreditamentoId, provinciaId, comuneId).then(function (data) {
                return data;
            });
        }



        function addCNDAccreditamentoSedeRecord(id) {
            return datacontext.cndAccreditamentoSede_get(id).then(function (data) {
                vm.list.cndAccreditamentiSedi.push(data);
            });
        }

        function loadCNDAccreditamentoSedeRecord(index, item) {
            vm.list.cndAccreditamentiSedi[index].Ref_Cognome = item.Ref_Cognome;
            vm.list.cndAccreditamentiSedi[index].Ref_Nome = item.Ref_Nome;
            vm.list.cndAccreditamentiSedi[index].Indirizzo = item.Indirizzo;
            vm.list.cndAccreditamentiSedi[index].Cap = item.Cap;
            vm.list.cndAccreditamentiSedi[index].Comune = item.Comune;
            vm.list.cndAccreditamentiSedi[index].Telefono = item.Telefono;
            vm.list.cndAccreditamentiSedi[index].Email = item.Email;
        }

        function deleteCNDAccreditamentoSede(item) {
            var msg = ' la sede : ' + item.Provincia;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAccreditamentoSede_delete(item.Id).then(function (data) {
                    if (data == "404") return logError('Errore cancellazione dati');

                    var index = vm.list.cndAccreditamentiSedi.indexOf(item)
                    vm.list.cndAccreditamentiSedi.splice(index, 1);
                });
            });
        }



        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************

        //Modal - cndAccreditamento Sede
        function addCNDAccreditamentoSede() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND_Accreditamento/modal/cndAccreditamentoSedeAdd.html?version=56',
                controller: 'cndAccreditamentoSedeAdd',
                backdrop: 'static',
                resolve: {
                    cndAccredSede: function () {
                        return null;
                    },
                    province: function () {
                        return vm.province;
                    },
                    cndAccreditamentoId: function () {
                        return vm.record.Id;
                    },
                    progettoId: function () {
                        return vm.record.ProgettoId;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "400") return logError('Errore di crezione! ');

                logSuccess('Dato salvato con successo! ');
                addCNDAccreditamentoSedeRecord(returnItem.Id);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        function editCNDAccreditamentoSede(index, objSede) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND_Accreditamento/modal/cndAccreditamentoSedeAdd.html?version=56',
                controller: 'cndAccreditamentoSedeAdd',
                backdrop: 'static',
                resolve: {
                    cndAccredSede: function () {
                        return objSede;
                    },
                    province: function () {
                        return vm.province;
                    },
                    cndAccreditamentoId: function () {
                        return vm.record.Id;
                    },
                    progettoId: function () {
                        return vm.record.ProgettoId;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "400") return logError('Errore di crezione! ');

                logSuccess('Dato modificato con successo! ');
                loadCNDAccreditamentoSedeRecord(index, returnItem);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };
        //************************END*****************************




        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR CF -#-#-#-#-#-#
        vm.existsCF = false;
        vm.searchCF = function (value) {
            //console.log('searchCF()');
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri
            vm.existsCF = false;
            return datacontext.cndAccreditamento_exists(vm.record.Id, value, '', '').then(function (data) {
                vm.existsCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR PIVA -#-#-#-#-#-#
        vm.existsPIVA = false;
        vm.searchPIVA = function (value) {
            //console.log('searchPIVA()');
            var requiredLen = 11;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.existsPIVA = false;
            return datacontext.cndAccreditamento_exists(vm.record.Id, '', value, '').then(function (data) {
                vm.existsPIVA = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.getValidPIVA = function (value) {
            var requiredLen = 11;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.validCF = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = function (value) {
            var requiredLen = 16;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.validCF = false;
            return datacontext.validazione_cf(value, false).then(function (data) {
                return vm.validCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.getValidFieldsCF = function () {
            var requiredLen = 16;
            vm.validFieldsCF = false;
            if (vm.record.L_CodiceFiscale == undefined) return;
            if (vm.record.L_CodiceFiscale.length != requiredLen) return; //numero minimo di caratteri
            if (vm.record.L_Nome == undefined) return;
            if (vm.record.L_Cognome == undefined) return;
            if (vm.record.L_Sesso == undefined) return;
            if (vm.record.L_PaeseNascId == 0 && (vm.record.L_ComuneNascId == undefined || vm.record.L_ComuneNascId == 0)) return;
            if (vm.record.L_DtNasc == undefined || vm.record.L_DtNasc == '') return;
            var strDtNasc = common.dateToString(vm.record.L_DtNasc); //la data deve avere formato dd/MM/yyyy            
            return datacontext.validazione_fieldsCF(vm.record.L_CodiceFiscale, vm.record.L_Nome, vm.record.L_Cognome, vm.record.L_Sesso, strDtNasc, vm.record.L_PaeseNascId, vm.record.L_ComuneNascId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN = true;
        vm.getValidIBAN = function (value) {
            var requiredLen = 27;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri
            vm.validIBAN = false;
            return datacontext.validazione_iban(value).then(function (data) {
                return vm.validIBAN = data;
            });
        }

    }
})();
